/**
 * A minimal, internal Zustand store tracking in-flight HTTP request
 * count — plumbing for `GlobalLoader` (STEP 13), NOT one of the 8
 * named STEP 9 domain stores (Auth/Theme/Layout/Notifications/
 * Workspace/Hospital/Branch/Preferences) and deliberately kept out of
 * `store/` for that reason — this is API-layer infrastructure state,
 * not app/domain state a feature module would ever read or persist.
 */
import { create } from 'zustand';

interface RequestTrackerState {
  activeRequests: number;
  increment: () => void;
  decrement: () => void;
}

export const useLoadingStore = create<RequestTrackerState>()((set) => ({
  activeRequests: 0,
  increment: () => set((state) => ({ activeRequests: state.activeRequests + 1 })),
  decrement: () => set((state) => ({ activeRequests: Math.max(0, state.activeRequests - 1) })),
}));
